
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.47 10.47a.75.75 0 101.06 1.06L.47 10.47zm11.06-8.94A.75.75 0 0010.47.47l1.06 1.06zM1.53.47A.75.75 0 00.47 1.53L1.53.47zm8.94 11.06a.75.75 0 101.06-1.06l-1.06 1.06zm-8.94 0l10-10L10.47.47l-10 10 1.06 1.06zm-1.06-10l10 10 1.06-1.06-10-10L.47 1.53z"}})])
          )
        }
      }
    